module.exports = __webpack_public_path__ + "static/media/clock-green.6e934c07.svg";